import React from 'react';
import { Link } from 'react-router-dom';

export default function PropertyCardList({ properties }) {
    return (
        <div className="gap-6 grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 xl:grid-cols-4 mb-3">
            {properties?.map((property) => (
                <Link
                    to={`/selected-property/${property.id}`}
                    key={property.id}
                    className="flex flex-col justify-between bg-white shadow-md p-0 border border border-1 border-gray-100 border-gray-500 rounded-xl min-h-[370px] hover:shadow-lg transition-shadow no-underline text-black"
                >
                    <div className="relative p-3">
                        <img
                            src={property.property_image}
                            alt={property.name}
                            className="rounded-xl w-full h-44 object-cover"
                        />
                        <span className="top-6 left-6 absolute bg-white shadow px-3 py-1 rounded font-semibold text-black text-xs">
                            {property.num_houses || 0} Units
                        </span>
                    </div>
                    <div className="flex flex-col flex-1 px-4 py-3">
                        <p className="mb-1 text-gray-700 text-sm">
                            {property.location}
                        </p>
                        <h2 className="mb-2 font-bold text-lg">{property.name}</h2>
                        <div className="flex justify-between items-center mt-auto">
                            <Link
                                to={`/selected-property/${property.id}`}
                                className="flex items-center font-medium text-red-500 hover:text-red-700 underline underline-offset-2"
                            >
                                View Property
                                <span className="ml-1 text-lg">&#8594;</span>
                            </Link>
                            <button
                                className="bg-red-500 hover:bg-red-600 p-2 rounded text-white transition-colors"
                                title="Delete Property"
                            >
                                <svg xmlns="http://www.w3.org/2000/svg" className="w-5 h-5" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M19 7l-.867 12.142A2 2 0 0116.138 21H7.862a2 2 0 01-1.995-1.858L5 7m5 4v6m4-6v6M1 7h22M8 7V5a2 2 0 012-2h4a2 2 0 012 2v2" />
                                </svg>
                            </button>
                        </div>
                    </div>
                </Link>
            ))}
        </div>
    );
}